export const gitCommit = 'e6f9e61e'
